import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initObservability, ErrorBoundary } from "@/observability";

// Initialize error tracking + analytics before first render
// (no-op without REACT_APP_SENTRY_DSN / REACT_APP_POSTHOG_KEY).
initObservability();

const Fallback = () => (
  <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
    <p style={{ fontSize: 13, color: "#64748b" }}>
      Something went wrong. Please refresh the page.
    </p>
  </div>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary fallback={<Fallback />}>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);

// PWA: register the service worker (production only). Network-first HTML,
// cache-first hashed assets, API never cached — see public/sw.js. This is
// what makes the app installable (home-screen icon, own window) and
// resilient to connection blips at the front desk.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* registration failure is non-fatal — app works as a plain site */
    });
  });
}
